import React from "react";
import { Formik } from "formik";
import {
  MimaButton,
  MimaDateInput,
  MimaDropdown,
  MimaDropZone,
  MimaInput,
  MimaText,
  MimaTextArea,
  Modal,
} from "../../../components";
import { amountFormatter } from "../../../utils/utils";

const UpdateP2PSellerPayment = ({
  loading,
  onSubmit,
  closeModal,
  statusData,

  singleItem,
}) => {
  return (
    <Modal closeModal={closeModal}>
      <MimaText variant="subtitleBold" align="center" mb="7" width="38rem">
        Update Seller Payment
      </MimaText>
      <Formik
        initialValues={{
          amount: singleItem?.sellerCreditValue.amount,
          adminSellerPaymentDateTime: "",
          adminSellerPaymentProofUrls: [],
          files: [],
        }}
        onSubmit={onSubmit}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
        }) => (
          <div>
            <MimaText labelTitle="Seller" mb={2}>
              {`${singleItem.seller.firstname} ${singleItem.seller.lastname} - ${singleItem.seller.username}`}
            </MimaText>
            <MimaText mb={2} labelTitle="Confirm Seller was Paid">
              {amountFormatter(
                singleItem.sellerCreditValue.currencyCode
              ).format(singleItem?.sellerCreditValue.amount)}
            </MimaText>
            <MimaText mb={2} labelTitle="Confirm Reference Code">
              {singleItem?.referenceCode}
            </MimaText>
            <MimaInput
              name="amount"
              labelTitle="Amount"
              type="number"
              placeholder="Enter amount"
              value={values.amount}
              onChange={handleChange("amount")}
              onBlur={handleBlur("amount")}
              error={errors.amount}
              touched={touched.amount}
            />
            <MimaDateInput
              labelTitle="Admin Payment Date/Time"
              name="adminSellerPaymentDateTime"
              value={values.adminSellerPaymentDateTime}
              onChange={(text) => {
                setFieldValue("adminSellerPaymentDateTime", text);
              }}
              showTimeSelect
              onBlur={handleBlur}
              touched={touched.adminSellerPaymentDateTime}
              error={errors.adminSellerPaymentDateTime}
              mt={2}
              width={38}
            />

            <MimaDropZone
              title="Upload file"
              info="maximum file Size 1MB"
              maxNumOfImages={3}
              files={values.files}
              setFiles={(newFiles) => {
                setFieldValue("files", newFiles);
              }}
              labelTitle="Upload Admin Payment Proof Urls"
              name="adminSellerPaymentProofUrls"
            />
            <MimaButton
              title="Continue"
              width={38}
              onClick={handleSubmit}
              loading={loading}
            />
          </div>
        )}
      </Formik>
    </Modal>
  );
};
export default UpdateP2PSellerPayment;
